import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ArrowRight, Sparkles, Shield, FileText, Lock, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";

const pages = {
  "privacy": {
    title: "سياسة الخصوصية",
    icon: Lock,
    content: [
      { heading: "المقدمة", text: "نحن في \"وعي الغذاء صلاة\" نلتزم بحماية خصوصيتك. توضح هذه السياسة كيف نجمع ونستخدم ونحمي معلوماتك الشخصية عند استخدامك لموقعنا وخدماتنا." },
      { heading: "المعلومات التي نجمعها", text: "نجمع المعلومات التي تقدمها لنا مباشرة عند التسجيل، بما في ذلك: الاسم الكامل، عنوان البريد الإلكتروني، وصورة الملف الشخصي (عبر تسجيل الدخول بحساب Google). كما نجمع معلومات تقنية تلقائيًا مثل عنوان IP ونوع المتصفح وبيانات الاستخدام." },
      { heading: "كيف نستخدم معلوماتك", text: "نستخدم معلوماتك لتقديم خدماتنا وتحسينها، وإرسال إشعارات ورسائل متعلقة بالدورة، والتواصل معك بشأن حسابك أو استفساراتك. لن نبيع أو نشارك معلوماتك الشخصية مع أطراف ثالثة لأغراض تسويقية." },
      { heading: "حماية البيانات", text: "نتخذ تدابير أمنية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو الكشف أو التعديل أو الإتلاف. نستخدم تشفير SSL لحماية البيانات أثناء النقل." },
      { heading: "ملفات تعريف الارتباط", text: "نستخدم ملفات تعريف الارتباط (Cookies) لتحسين تجربة الاستخدام والحفاظ على جلسة تسجيل الدخول. يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال متصفحك." },
      { heading: "حقوقك", text: "يحق لك طلب الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. للاستفسار، يُرجى التواصل معنا عبر البريد الإلكتروني." },
      { heading: "تحديث السياسة", text: "قد نقوم بتحديث هذه السياسة من وقت لآخر. سنُعلمك بأي تغييرات جوهرية عبر البريد الإلكتروني أو إشعار على الموقع." }
    ]
  },
  "terms": {
    title: "شروط الاستخدام",
    icon: FileText,
    content: [
      { heading: "قبول الشروط", text: "باستخدامك لموقع \"وعي الغذاء صلاة\" أو التسجيل في الدورة، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه الشروط، يُرجى عدم استخدام الموقع أو الخدمات." },
      { heading: "وصف الخدمة", text: "نقدم دورة تعليمية رقمية عبر الإنترنت بعنوان \"وعي الغذاء صلاة\" تتضمن جلسات مباشرة عبر Zoom ومواد تعليمية مصاحبة. المحتوى المقدم هو لأغراض تثقيفية وتوعوية ولا يُعد بديلاً عن الاستشارة الطبية أو النفسية المتخصصة." },
      { heading: "التسجيل والحساب", text: "يتم التسجيل عبر حساب Google. أنت مسؤول عن الحفاظ على سرية حسابك وعن جميع الأنشطة التي تتم من خلاله." },
      { heading: "الملكية الفكرية", text: "جميع المحتويات المقدمة في الدورة، بما في ذلك النصوص والتسجيلات والمواد التعليمية والكتيبات، محمية بموجب حقوق الملكية الفكرية. يُحظر نسخ أو توزيع أو إعادة نشر أي محتوى دون إذن كتابي مسبق." },
      { heading: "سلوك المستخدم", text: "يلتزم المستخدم بالتعامل باحترام مع المشاركين الآخرين والمقدمين أثناء الجلسات المباشرة. يُحظر تسجيل الجلسات أو بثها دون إذن. أي سلوك مسيء قد يؤدي إلى إلغاء المشاركة دون استرداد." },
      { heading: "تحديد المسؤولية", text: "لا نتحمل المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناتجة عن استخدام الموقع أو المشاركة في الدورة. المحتوى المقدم هو لأغراض تعليمية فقط." },
      { heading: "التعديلات", text: "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. ستصبح التعديلات سارية فور نشرها على الموقع." },
      { heading: "القانون المُطبّق", text: "تخضع هذه الشروط وتُفسَّر وفقًا للقوانين المعمول بها. أي نزاع ينشأ يتم حله وديًا أولاً، وفي حال عدم التوصل لحل، يُحال للجهات القضائية المختصة." }
    ]
  },
  "refund": {
    title: "سياسة الاسترداد",
    icon: AlertTriangle,
    isRefund: true,
    content: [
      { heading: "سياسة عدم الاسترداد", text: "نظرًا للطبيعة الرقمية لهذا المنتج، فإن جميع المبالغ المدفوعة غير قابلة للاسترداد بعد إتمام عملية الشراء. بمجرد تأكيد الدفع، يُعتبر البيع نهائيًا ولا يمكن التراجع عنه.", highlight: true },
      { heading: "لماذا لا نقدم استردادًا؟", text: "دورة \"وعي الغذاء صلاة\" هي منتج رقمي يتضمن الوصول الفوري إلى جلسات مباشرة ومواد تعليمية. بمجرد منح الوصول، لا يمكن \"إعادة\" الخدمة الرقمية كما هو الحال مع المنتجات المادية. لذلك، لا يمكننا تقديم أي استرداد كلي أو جزئي." },
      { heading: "ما يشمله الشراء", text: "عند الشراء تحصل على: حضور ٤ جلسات مباشرة عبر Zoom، كتيب تطبيقي، تمارين عملية، وأدوات تُرافقك بعد انتهاء الرحلة. كل هذه المواد متاحة لك فور التسجيل." },
      { heading: "قبل الشراء", text: "نشجعك على قراءة جميع المعلومات المتاحة على الموقع بعناية قبل اتخاذ قرار الشراء. إذا كان لديك أي استفسار، تواصل معنا أولاً عبر البريد الإلكتروني وسنكون سعداء بالإجابة عن جميع أسئلتك." },
      { heading: "الاستثناءات", text: "في حال إلغاء الدورة بالكامل من قِبلنا لأي سبب، سيتم استرداد المبلغ كاملاً لجميع المسجلين. هذا هو الاستثناء الوحيد لسياسة عدم الاسترداد." },
      { heading: "الموافقة", text: "بإتمام عملية الشراء، فإنك تُقر بأنك قرأت وفهمت ووافقت على سياسة عدم الاسترداد هذه. إذا كنت لا توافق على هذه السياسة، يُرجى عدم إتمام عملية الشراء.", highlight: true }
    ]
  }
};

const LegalPage = () => {
  const { page } = useParams();
  const navigate = useNavigate();
  const data = pages[page];

  if (!data) {
    return <Navigate to="/" replace />;
  }

  const Icon = data.icon;

  return (
    <div className="min-h-screen bg-[#FAFBFF]">
      {/* Header */}
      <header className="bg-white border-b border-[#E2E8F0] py-4 px-4 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#7C3AED] hover:text-[#6D28D9] font-medium transition-colors">
            <ArrowRight className="w-5 h-5" />
            <span>العودة للموقع</span>
          </button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-[#7C3AED] to-[#EC4899] rounded-lg flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
            <span className="font-bold text-[#1A1D3D] text-sm" style={{ fontFamily: 'Cairo, sans-serif' }}>وعي الغذاء صلاة</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 md:py-20 px-4 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center shadow-lg ${data.isRefund ? 'bg-gradient-to-br from-[#EF4444] to-[#F97316] shadow-red-500/20' : 'bg-gradient-to-br from-[#7C3AED] to-[#EC4899] shadow-purple-500/20'}`}>
              <Icon className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-[#1A1D3D] mb-3" style={{ fontFamily: 'Cairo, sans-serif' }}>
              {data.title}
            </h1>
            <p className="text-sm text-[#8B92B3]">آخر تحديث: {new Date().toLocaleDateString('ar', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          {/* No Refund Warning Banner */}
          {data.isRefund && (
            <div className="bg-gradient-to-r from-[#EF4444]/10 to-[#F97316]/10 border-2 border-[#EF4444]/30 rounded-2xl p-6 mb-10 text-center">
              <Shield className="w-10 h-10 text-[#EF4444] mx-auto mb-3" />
              <p className="text-lg md:text-xl font-bold text-[#EF4444]" style={{ fontFamily: 'Cairo, sans-serif' }}>
                جميع المبالغ المدفوعة غير قابلة للاسترداد
              </p>
              <p className="text-sm text-[#4A5078] mt-2">نظرًا للطبيعة الرقمية للمنتج</p>
            </div>
          )}

          {/* Sections */}
          <div className="space-y-8">
            {data.content.map((section, index) => (
              <div 
                key={index} 
                className={`rounded-2xl p-6 md:p-8 border ${section.highlight ? 'bg-gradient-to-br from-[#FEF2F2] to-[#FFF7ED] border-[#EF4444]/20' : 'bg-white border-[#E2E8F0]'}`}
              >
                <div className="flex items-start gap-3 mb-3">
                  <span className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold text-white ${section.highlight ? 'bg-gradient-to-br from-[#EF4444] to-[#F97316]' : 'bg-gradient-to-br from-[#7C3AED] to-[#EC4899]'}`}>
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h2 className="text-lg md:text-xl font-bold text-[#1A1D3D]" style={{ fontFamily: 'Cairo, sans-serif' }}>
                    {section.heading}
                  </h2>
                </div>
                <p className="text-[#4A5078] leading-loose text-sm md:text-base pr-11">
                  {section.text}
                </p>
              </div>
            ))}
          </div>

          {/* Footer note */}
          <div className="mt-12 text-center">
            <p className="text-sm text-[#8B92B3]">
              لأي استفسار، يمكنك التواصل معنا عبر أرقام الواتس آب المتوفرة في الصفحة الرئيسية.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
